module.exports = __webpack_public_path__ + "img/china-pr-logo-icon.49693dd4.png";